import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getMyManagerRoles, type DepartamentoRol } from '../api/departamentoManagers';

/**
 * Hook para obtener los departamentos de los que el usuario actual es manager
 */
export function useManagerDepartments() {
  const { user, bootstrapped } = useAuth();
  const [departments, setDepartments] = useState<DepartamentoRol[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!bootstrapped) {
      return;
    }

    if (!user) {
      setDepartments([]);
      setLoading(false);
      return;
    }

    // Los admins tienen acceso a todos los departamentos
    const isAdmin = user.roles?.includes('admin');
    if (isAdmin) {
      setDepartments([
        'facturacion',
        'att_familias',
        'att_alumnado',
        'att_profesorado',
        'admisiones',
        'hr',
      ]);
      setLoading(false);
      return;
    }

    // Obtener departamentos de los que es manager
    const loadDepartments = async () => {
      try {
        setLoading(true);
        const roles = await getMyManagerRoles();
        setDepartments(roles);
      } catch (error: any) {
        // En caso de error, establecer como array vacío pero no bloquear
        setDepartments([]);
      } finally {
        setLoading(false);
      }
    };

    loadDepartments();
  }, [user, bootstrapped]);

  return { departments, loading };
}

